import React from 'react';
import { FileText, Unlock, TrendingUp, Shield } from 'lucide-react';

/** Purpose: Executes { records, active permissions }. Inputs: { records, activePermissions }. Output: Operation result. */
export default function StatsCards({ records, activePermissions }) {
  const encryptedCount = records.filter(r => r.encrypted).length;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="group relative overflow-hidden bg-white rounded-2xl p-5 sm:p-6 shadow-card card-lift border border-slate-200/60">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-brand-50 to-transparent rounded-bl-full opacity-80" />
        <div className="relative flex items-start justify-between">
          <div>
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Total Records</p>
            <p className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 tracking-tight">{records.length}</p>
            <p className="text-xs text-slate-400 mt-2 flex items-center gap-1">
              <TrendingUp className="w-3 h-3" />
              All time
            </p>
          </div>
          <div className="bg-gradient-to-br from-brand-500 to-brand-600 p-3 rounded-xl shadow-glow-blue">
            <FileText className="w-5 h-5 text-white" />
          </div>
        </div>
      </div>

      <div className="group relative overflow-hidden bg-white rounded-2xl p-5 sm:p-6 shadow-card card-lift border border-slate-200/60">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-emerald-50 to-transparent rounded-bl-full opacity-80" />
        <div className="relative flex items-start justify-between">
          <div>
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Active Permissions</p>
            <p className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 tracking-tight">{activePermissions.length}</p>
            <p className="text-xs text-slate-400 mt-2 flex items-center gap-1">
              <Unlock className="w-3 h-3" />
              Currently shared
            </p>
          </div>
          <div className="bg-gradient-to-br from-emerald-500 to-green-600 p-3 rounded-xl shadow-md">
            <Unlock className="w-5 h-5 text-white" />
          </div>
        </div>
      </div>

      <div className="group relative overflow-hidden bg-white rounded-2xl p-5 sm:p-6 shadow-card card-lift border border-slate-200/60">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-violet-50 to-transparent rounded-bl-full opacity-80" />
        <div className="relative flex items-start justify-between">
          <div>
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Encrypted</p>
            <p className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 tracking-tight">{encryptedCount}</p>
            <p className="text-xs text-slate-400 mt-2 flex items-center gap-1">
              <Shield className="w-3 h-3" />
              Protected records
            </p>
          </div>
          <div className="bg-gradient-to-br from-violet-500 to-purple-600 p-3 rounded-xl shadow-glow-purple">
            <Shield className="w-5 h-5 text-white" />
          </div>
        </div>
      </div>
    </div>
  );
}
